var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-container"},[_c('div',{staticClass:"header-content"},[_vm._m(0),_c('nav',[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/"}},[_vm._v(" Accueil ")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logos-img",attrs:{"src":require("@/assets/img/Logos.png"),"alt":"France Rugby x Carte Noire"}})])
}]

export { render, staticRenderFns }